import { render, staticRenderFns } from "./weekOther.vue?vue&type=template&id=3aa687ed"
import script from "./weekOther.vue?vue&type=script&lang=js"
export * from "./weekOther.vue?vue&type=script&lang=js"
import style0 from "./weekOther.vue?vue&type=style&index=0&id=3aa687ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports